import { Grid, Box, Stack } from '@mui/material';
import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { ControlledTextInput, WsButton } from 'wisestep-base';

import LayoutPage from '../../../appsettings/components/faqs/LayoutPage';
import FAQDetailsCommonFields from '../FAQDetailsCommonFields';
import FAQDetailsPage from '../FAQDetailsPage';
import { browserExtensions } from '../helper/QuestionListHelper';
export type ChildComponentType = {
  id: string;
  label: string;
};
export interface IFAQsProp {
  isFromSettings?: boolean;
  topicArrayList?: Array<ChildComponentType>;
}

const BrowserExtension = ({ isFromSettings }: IFAQsProp) => {
  return isFromSettings ? (
    <LayoutPage>
      <ChildComponent />
    </LayoutPage>
  ) : (
    <FAQDetailsPage>
      <ChildComponent />
    </FAQDetailsPage>
  );
};

const ChildComponent = () => {
  const methods = useForm();

  const [browserExtensionList, setBrowserExtensionList] = useState<
    { title: string; text: string }[] | undefined
  >(browserExtensions);

  const [textValue, setTextValue] = useState('');

  const handleOnClick = () => {
    const findText =
      browserExtensions && browserExtensions?.length > 0
        ? browserExtensions?.filter((b) => b?.title.toUpperCase().includes(textValue))
        : undefined;
    setBrowserExtensionList(findText);
  };
  return (
    <Box pt={2}>
      <FormProvider {...methods}>
        <Grid item xs={12} pb={2} bgcolor="white" p={2}>
          <Stack direction="row" spacing={1}>
            <ControlledTextInput
              placeholder="Search..."
              name="search"
              type="text"
              fullWidth
              required
              autoComplete="text"
              value={textValue}
              onChange={(e) => setTextValue(e.target.value)}
            />
            <WsButton disabled={!textValue} size="large" onClick={handleOnClick}>
              Search
            </WsButton>
          </Stack>
        </Grid>
        <Grid container spacing={2} pt={2}>
          {browserExtensionList &&
            browserExtensionList?.length > 0 &&
            browserExtensionList?.map((list, index) => (
              <Grid item xs={12} key={index}>
                <FAQDetailsCommonFields title={list.title} text={list.text} />
              </Grid>
            ))}
        </Grid>
      </FormProvider>
    </Box>
  );
};

export default BrowserExtension;
